export default "__VITE_ASSET__e946e902__"